import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { zustandPlugin } from '@/modules/shared/openreplay'
import type { DayType } from '@/modules/drivers/tabs/registry/schedule/constants/DayType'
import { DAY_TYPE_TABS, type DayTypeFormType } from './timesheetStore'

export type { DayTypeFormType }
export { DAY_TYPE_TABS }

type ScheduleState = {
  selectedDays: string[]
  formTab: DayTypeFormType
  selectedDayType: DayType | null
  isOpenDayTypeModal: boolean
  isLoading: boolean
  refreshKey: number
}

type ScheduleActions = {
  setSelectedDays: any
  setFormTab: (tab: DayTypeFormType) => void
  setSelectedDayType: (type: DayType | null) => void
  setIsOpenDayTypeModal: (open: boolean) => void
  setIsLoading: (loading: boolean) => void
  refresh: () => void
  reset: () => void
}

const initial: ScheduleState = {
  selectedDays: [],
  formTab: 'work',
  selectedDayType: null,
  isOpenDayTypeModal: false,
  isLoading: false,
  refreshKey: 0,
}

export const useScheduleStore = create<ScheduleState & ScheduleActions>()(
  devtools(
    zustandPlugin(
      (set) => ({
        ...initial,
        setSelectedDays: (selectedDays) =>
          set(
            (s) => ({
              selectedDays:
                typeof selectedDays === 'function'
                  ? selectedDays(s.selectedDays)
                  : selectedDays,
            }),
            false,
            'setSelectedDays',
          ),
        setFormTab: (formTab) => set({ formTab }, false, 'setFormTab'),
        setSelectedDayType: (selectedDayType) =>
          set({ selectedDayType }, false, 'setSelectedDayType'),
        setIsOpenDayTypeModal: (isOpenDayTypeModal) =>
          set({ isOpenDayTypeModal }, false, 'setIsOpenDayTypeModal'),
        setIsLoading: (isLoading) => set({ isLoading }, false, 'setIsLoading'),
        refresh: () =>
          set((s) => ({ refreshKey: s.refreshKey + 1 }), false, 'refresh'),
        reset: () => set(initial, false, 'reset'),
      }),
      'schedule',
    ),
    { name: 'EasyTacho', store: 'schedule' },
  ),
)
